/**
 * Einheitliche Label-Kette für LADS-Knoten (Device, FunctionalUnit, Function):
 *
 *   componentName → displayName → browseName
 *
 * componentName ist das user-writable Label (Admin-Override), displayName der
 * Quell-Anzeigename (bei essentim-Geräten dynamisch vom Treiber gesetzt),
 * browseName der konstante Struktur-Name. Das Backend liefert die drei Felder
 * granular (gleiche Konvention serverseitig: shared/node-label.util.ts im
 * lcc-backend, dort für den Excel-Export) — JEDE Anzeige-Stelle im Frontend
 * MUSS diese Kette über diesen Helper anwenden, sonst divergieren die Namen
 * zwischen Aktuelle Werte, Auswertung, Export und Fehlermeldungen.
 */
export type LabeledNode = {
  componentName?: string | null;
  displayName?: string | null;
  browseName?: string | null;
};

export function resolveNodeLabel(node: LabeledNode, fallback = ""): string {
  return node.componentName || node.displayName || node.browseName || fallback;
}
